import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";

const AuditSubmitConfirmationDialog = (props: any) => {
  const { open, onClose, onConfirm, showSuccess } = props;

  return (
    <Fragment>
      <div>
        <Dialog className="pw-confirmation-dialog" open={open}>
          <div className="pw-confirmation-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text">
                {showSuccess ? "Thank you" : "Confirm submission"}
              </div>
              <div className="cursor-pointer">
                <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={onClose}
                />
              </div>
            </div>

            {!showSuccess ? (
              <div className="w-full mt-4 mb-2 pw-color-neutral-900 text-sm">
                <div>
                  Are you sure you want to submit the verification?
                  <br />
                  Once submitted the audit link will no longer be accessible and
                  no changes can be made.
                </div>
              </div>
            ) : (
              <div className="flex flex-col justify-center items-center w-full mt-4 mb-8 pw-color-neutral-900 text-sm bold">
                <img
                  src="assets/icons/check-bg-green.svg"
                  className="w-12 mb-4"
                  alt=" "
                />
                <div className="font-bold">
                  Your verification has been submitted
                </div>
              </div>
            )}
          </div>
          {!showSuccess ? (
            <div className="flex flex-row justify-end pw-confirmation-dialog-footer w-full gap-6 py-3 mt-4">
              <div
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
                onClick={onClose}
              >
                Cancel
              </div>
              <button
                className={`pw-bunit-button-primary pw-bunit-button-next text-white font-bold cursor-pointer bg-primary px-4`}
                onClick={onConfirm}
              >
                Submit
              </button>
            </div>
          ) : (
            ""
          )}
        </Dialog>
      </div>
    </Fragment>
  );
};

export default AuditSubmitConfirmationDialog;
